"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.initGlobalBehaviors = void 0;
var GlobalBehaviors_1 = require("./GlobalBehaviors");
var constants_1 = require("../constants");
function initGlobalBehaviors() {
    var currentStorage = window[constants_1.STORAGE_GLOBAL_KEY];
    var storage = new GlobalBehaviors_1.GlobalBehaviors();
    if (currentStorage) {
        if (storage.version <= currentStorage.version) {
            return currentStorage;
        }
        storage.migrate(currentStorage);
    }
    window[constants_1.STORAGE_GLOBAL_KEY] = storage;
    return storage;
}
exports.initGlobalBehaviors = initGlobalBehaviors;
//# sourceMappingURL=initGlobalBehaviors.js.map